import { createFileRoute } from '@tanstack/react-router';

import { PerformancePage, performanceState, toSearch } from '@/features/performance';
import { chartsDefaultOpen } from '@/patterns';
import { currentPeriod } from '@/shared/lib/dates';

export const Route = createFileRoute('/_app/performance/')({
  component: function Performance() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    const now = currentPeriod();
    const charts = chartsDefaultOpen();
    const state = performanceState(search, now, charts);
    return <PerformancePage state={state} onChange={(patch) => void navigate({ search: toSearch({ ...state, ...patch }, now, charts), replace: true })} />;
  },
});
